module.exports = __webpack_public_path__ + "static/media/logo-netexial.4718364f.png";